import React, { useState, useEffect } from "react";
import { CgMenuMotion } from "react-icons/cg";

import classes from "./Header.module.css";
import adminAlternative from "../../Assets/adminAlternative.png";
import littleLogo from "../../Assets/Little_logo.jpg";
import loadingGif from "../../Assets/loading-gif.gif";
import { useHistory } from "react-router-dom";
import ChangePassword from "../Dashboard/ChangePassword";
import { GrClose } from "react-icons/gr";
import useHttp from "../../Hooks/use-http";
import EditProfile from "./EditProfile";
import Message from "../../Modal/Message";
import Notification from "./Notification";
import Cookies from "js-cookie"; // Import js-cookie
import { useFirstUrl } from "../../Context/FirstUrlContext";

const Nav = (props) => {
  const history = useHistory();
  const [isAdminPhotoClicked, setIsAdminPhotoClicked] = useState(false);
  const [isEditProfileClicked, setIsEditProfileClicked] = useState(false);
  const [isResponse, setIsResponse] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const { firstUrl, resetFirstUrl } = useFirstUrl();
  
  useEffect(() => {
    const checkScreenSize = () => {
      // Show first name only when width is below 365px (mobile size)
      setIsSmallScreen(window.innerWidth < 365);
    };
    
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const corporateImage = localStorage.getItem("corporateLogo");
  const adminImage = localStorage.getItem("userImage");

  const sideMenuClickHandler = () => {
    props.sideMenuOpen();
  };

  const adminPhotoClickHandler = () => {
    setIsAdminPhotoClicked((prev) => !prev);
  };

  const editProfileClickHandler = () => {
    setIsEditProfileClicked(true);
    setIsAdminPhotoClicked(false);
  };
  setTimeout(() => {
    document.getElementById("a")?.addEventListener("click", () => {
      document.body.style.overflow = "hidden";
    });
  });

  const logoutHandler = () => {
    // Clear all localStorage items related to login session
    localStorage.removeItem("userType");
    localStorage.removeItem("user");
    localStorage.removeItem("adminName");
    localStorage.removeItem("roleId");
    localStorage.removeItem("adminDepartmentID");
    localStorage.removeItem("corpId");
    localStorage.removeItem("cpName");
    localStorage.removeItem("enabledModule");
    localStorage.removeItem("corporateAddress");
    localStorage.removeItem("corporateImage");
    localStorage.removeItem("userImage");
    localStorage.removeItem("shiftStartOTPFromLocalStorage");
    localStorage.removeItem("shiftEndOTPFromLocalStorage");

    resetFirstUrl();

    // localStorage.removeItem("token");
    Cookies.remove("token");

    localStorage.setItem("login", false);
    history.push("/home");
    sessionStorage.removeItem("splashFlag");
    props.setIsLoggedIn(false);
  };
  const handleImageError = (e) => {
    e.target.onerror = null; // Prevents infinite loop in case adminAlternative also fails
    e.target.src = adminAlternative;
  };

  const validCorporateImage =
    corporateImage &&
    corporateImage !== "undefined" &&
    corporateImage.trim() !== ""
      ? corporateImage
      : littleLogo;

  // Get admin name and extract first name for small screens
  const adminName = localStorage.getItem("adminName") || "Admin";
  const displayName = isSmallScreen 
    ? adminName.split(" ")[0] 
    : adminName;

  return (
    <React.Fragment>
      <div className={classes.container}>
        <div className={classes.sub}>
          <CgMenuMotion
            className={classes.menuIcon}
            onMouseEnter={sideMenuClickHandler}
            onClick={() => {props.sideMenuOpen()}}
          />
          <img
            src={littleLogo}
            alt=""
            className={classes.logo}
            style={{ cursor: "pointer" }}
            // onClick={() => history.push("/dashboard")}
            onClick={() => history.push(firstUrl)}
          />
        </div>
        <div className={classes.orgDetails}>
          {localStorage.getItem("userType") !== "AccountManager" && (
            <React.Fragment>
              <div>
                {localStorage.getItem("roleId") !== "1" && (
                  <img
                    src={validCorporateImage}
                    alt="logo"
                    className={classes.logo}
                  />
                )}
              </div>
              {/* )} */}
            </React.Fragment>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
              <p style={{ 
                margin: 0, 
                fontSize: "14px", 
                fontWeight: "500", 
                fontFamily: "Poppins",
                color: "#1a1a1a",
                lineHeight: "1.3"
              }}>
                {displayName}
              </p>
              <p style={{ 
                marginTop: "2px", 
                fontSize: "10px", 
                fontWeight: "400", 
                fontFamily: "Poppins",
                color: "#666",
                lineHeight: "1.3"
              }}>
                {localStorage.getItem("roleDisplayName") || ""}
              </p>
            </div>
            <img
              src={adminImage ? adminImage : adminAlternative}
              alt="Admin"
              className={classes.adminPhoto}
              onClick={adminPhotoClickHandler}
              onError={handleImageError}
            />
            {/* <Notification
              setIsAdminPhotoClicked={setIsAdminPhotoClicked}
              isAdminPhotoClicked={isAdminPhotoClicked}
            /> */}
          </div>
        </div>
        {isAdminPhotoClicked && (
          <React.Fragment>
            <div
              className={classes.backdrop}
              onClick={() => setIsAdminPhotoClicked(false)}
            ></div>
            <div className={classes.adminPanel}>
              <div className={classes.header}>
                <p className={classes.adminName}>
                  {localStorage.getItem("adminName")}
                </p>
                <p className={classes.adminOrg}>
                  {localStorage.getItem("roleDisplayName")}
                </p>
              </div>
              <p
                className={classes.changePassword}
                onClick={editProfileClickHandler}
                id="a"
              >
                Edit Profile
              </p>
              <hr />
              <p className={classes.logout} onClick={logoutHandler}>
                Logout
              </p>
            </div>
          </React.Fragment>
        )}
        {/* </div> */}
      </div>
      {isEditProfileClicked && (
        <EditProfile
          setIsResponse={setIsResponse}
          setIsEditProfileClicked={setIsEditProfileClicked}
          adminName={localStorage.getItem("adminName")}
          adminOrg={localStorage.getItem("cpName")}
          adminPhoto={adminImage ? adminImage : adminAlternative}
        />
      )}
      {isResponse && (
        <Message
          type={isResponse}
          message="Admin details has been updated successfully"
        />
      )}
    </React.Fragment>
  );
};

export default Nav;
